import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectorRef , ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';
import { DatePipe } from '@angular/common';
import { DatePikerPage } from '../date-piker/date-piker.page';
import { LoadingController, ModalController, ToastController} from '@ionic/angular';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { AdvertisementPage } from '../advertisement/advertisement.page';
import { AddCall } from 'src/providers/addvCall';
import { Geolocation } from '@ionic-native/geolocation/ngx';
declare var google;
import { Payment } from 'src/providers/payment';
import { SuccessPage } from 'src/app/success/success.page';
import { knetPaymentDetailsPage } from '../success/knetPaymentDetails/knetPaymentDetails.page';
import { PrescriptionpopupPage } from '../prescriptionpopup/prescriptionpopup.page';
import { HttpClient } from '@angular/common/http';
import {  HttpParams } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as htmlToPdfmake from 'html-to-pdfmake';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
interface DecryptedMemberContentResponse {
  data: { Terms_and_conditions: string }[];
}

@Component({
  selector: 'app-prescription',
  templateUrl: './prescription.page.html',
  styleUrls: ['./prescription.page.scss'],
})
export class PrescriptionPage implements OnInit {
  @ViewChild('map', { static: false }) mapElement: ElementRef;
  @Input() typeid: any;
  @Input() showTypeofBooking: string;
  @Output() ChangeEventPharma = new EventEmitter<string>();
  @Output() ChangeEvent = new EventEmitter<string>();
  @Input() newAddress: any;
  private fkey = CryptoJS.enc.Hex.parse(
    '00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff'
  );
  private fiv = CryptoJS.enc.Hex.parse('00112233445566778899aabbccddeeff');
  map: any;
  latitude: number;
  longitude: number;
  address: string = '';
  presentView: string;
  isShowHeaderValue: any;
  patientid: any;
  advFilter: boolean;
  deleteBox: boolean;
  deleteRow: boolean;
  hideRow: boolean;
  hideRow1: boolean;
  isConfirmed : boolean
  showRow: boolean;
  backValue: string;
  orderDetails: boolean;
  prescription: boolean;
  prescriptionhitory: boolean;
  trackOrders: boolean;
  prescriptionHistory = [];
  PreHisAdvFilter = [];
  prescriptionId: any;
  PerticularPharPre = [];
  preIdConf: any;
  orderId: any;
  deliveryAddress: any;
  paidAmount: any;
  paymentStatus: any;
  DeletePescript = [];
  medicineId: any;
  addressTextArea: any;
  orderTracking = [];
  selectedIndex: any;
  dltNotify: boolean;
  pharmacyStatusId: any;
  filterFromDate: any;
  filterToDate: any;
  indexFor: any;
  docName: any;
  orderNum: any;
  dateTime: any;
  statusCondition = [];
  filterStatus: boolean = false;
  appoinbackhead: boolean = false;
  EmtyData: any = null;
  selectedDate: any;
  pageNo: number;
  srcFromDate: any;
  srcToDate: any;
  nextCount: any;
  dynClass: string;
  removeamount: any = 0;
  addImg: any;
  leng: Number;
  tymVal: any;
  refEvent: any;
  scrollEvent: any;
  confirmloc: boolean = false;
  referenceid: any;
  bookingOrderId: any;
  paymentGatewayName: any;
  payType: any;
  gopayment: boolean = false;
  statement: boolean = false;
  dateSorting: boolean;
  dateBasedSortingOrder: any = null;
  currentDate : any;
  filterarray = [];
  terms_and_condition_file: string;
  Location : any;
  constructor(
    public activeRoute: ActivatedRoute,
    public router: Router,
    private services: ServicesProvider,
    private datePipe: DatePipe,
    public modalCtrl: ModalController,
    public PopupalertPage: PopupalertPage,
    public loadingController: LoadingController,
    public toastCtrl: ToastController,
    public addCall: AddCall,
    public geolocation: Geolocation,
    private payment: Payment,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private file: File,
    private fileOpener: FileOpener,
  ) { }

  ngOnInit() {
    console.log('alert');
   }

  doRefresh(event) {
    this.patientid = localStorage.getItem('patient_id');
    this.refEvent = event;
    this.pageNo = 1;
    this.EmtyData = null;
    this.filterStatus = false;
    this.prescriptionHistory = [];
    this.filterarray = [];
    if(this.presentView == 'prescriptionhis'){
      this.getPresc("");
    }else{
      this.getPrescHis();
    }
  }
  refFunc() {
    if (this.refEvent) {
      this.refEvent.target.complete();
    }
  }
  infyFunc() {
    if (this.scrollEvent) {
      this.scrollEvent.target.complete();
    }
  }

  loadMoreData(event,fromPage) {
    if (this.nextCount > 0) {
      console.log(this.nextCount);
      this.scrollEvent = event;
      console.log(event);
      this.pageNo += 1;
      if(fromPage == 'Booking'){
      this.getPrescHis();
      }else {
        this.getPresc(fromPage);
      }
    }
  }



  //---------Prescrtion Add Address Popup--------------------//

  async Addaddress(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PrescriptionpopupPage,
      cssClass: 'Address_add',
      componentProps: {
        Address: this.address
      },
    });
    await alert.present();
    alert.onDidDismiss().then((data) => {
      debugger;
      console.log('ondidDismiss=>', data.data);
      if(data.data.status != ''){
        this.address = data.data.status;
      }else{
        this.address = '';
        this.isConfirmed = false;
      }

    });
  }



  //---------Prescrtion Add Address Popup--------------------//



  //-----------------------SOME SPECIAL FUNCTION----------------
  async AlertpopupPrc(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      componentProps: {
        msg: msg,
        sts: status,
      },
    });
    await alert.present();
    alert.onDidDismiss().then((data) => {
      console.log('ondidDismiss=>', data.data);
    });
  }

  async Alertpopup(msg, status, from_data = 'normal') {
    if (from_data == 'normal') {
      var cssClassData = 'class_alert';
    } else {
      cssClassData = 'class_alert_confirm';
    }
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: cssClassData,
      componentProps: {
        msg: msg,
        sts: status,
      },
    });
    await alert.present();

    alert.onDidDismiss().then((data) => {
      console.log('ondidDismiss=>', data.data);
      if (data.data == 'Success') {
        this.router.navigate(['payment']);
      } else if (data.data == 'yes') {
        this.okEvent();
      } else if (data.data == 'no') {
        this.cancelEvent();
      } else if (data.data == '88') {
        this.cancelPharPresOrder();
      }
    });
  }

  async Alertpopup2(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      componentProps: {
        msg: msg,
        sts: status,
      },
    });
    await alert.present();
    alert.onDidDismiss().then((data) => {
      console.log('ondidDismiss=>', data.data);
      if (data.data == 'Success') {
        this.presentView = 'prescription';
        this.prescription = true;
        this.prescriptionhitory = false;
        this.orderDetails = false;
        this.trackOrders = false;
        this.EmtyData = null;
        this.pageNo = 1;
        this.prescriptionHistory = [];
        this.getPrescHis();
      }

      if (data.data == 'no') {
        this.toChange();
      } else if (data.data == 'yes') {
        this.confirmloc = true;
        this.goToPayment();
      } else if (data.data == '88') {
        this.cancelPharPresOrder();
      }
    });
  }

  async presentLoading() {
    const loader = await this.loadingController.create({
      message: 'Loading......please Wait',
    });
    await loader.present();
  }

  async presentToast(msg) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  async openDatePicker(fromOrTo) {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        selectedDate: this.selectedDate,
        calenderType: 'to',
        curdate:
          new Date().toString().split(' ')[0] +
          ', ' +
          new Date().toString().split(' ')[1] +
          ' ' +
          new Date().toString().split(' ')[2],
      },
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss().then((data) => {
      console.log(data);
      if (data.data && fromOrTo == 'From') {
        let Date = data.data;
        this.filterFromDate =
          Date.getFullYear() +
          '-' +
          ('0' + (Date.getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + Date.getDate()).slice(-2);
        this.srcFromDate = this.getFormattedDateTime(Date, 'Date1');
      } else if (data.data && fromOrTo == 'To') {
        let Date = data.data;
        this.filterToDate =
          Date.getFullYear() +
          '-' +
          ('0' + (Date.getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + Date.getDate()).slice(-2);
        this.srcToDate = this.getFormattedDateTime(Date, 'Date1');

        if (this.filterToDate < this.filterFromDate) {
          this.filterToDate = '';
          this.srcToDate = '';
          this.presentToast(this.addCall.title601);
        }
      }
    });
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return '';
    }

    let Value;
    switch (callFor) {
      case 'Time':
        if (dateTime.indexOf('T') > -1) {
          Value = dateTime.split('T')[1];
        } else if (dateTime.indexOf(' ') > -1) {
          Value = dateTime.split(' ')[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(':');
        let H = +String(Value).substr(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = H < 12 || H === 24 ? 'AM' : 'PM';
        let timeString = h + String(Value).substr(hourEnd, 3) + ' ' + ampm;
        return timeString;
      case 'Date':
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), 'dd MMM yyyy');
        } else {
          let dateCall = new Date(dateTime);
          let months = [
            'يناير',
            'فبراير',
            'مارس',
            'إبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ];
          let arDate =
            dateCall.getDate() +
            '-' +
            months[dateCall.getMonth()] +
            '-' +
            dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
      case 'DateTime':
        return this.datepipeTransform(new Date(dateTime), 'dd MMM yyyy h:mm a');
      case 'Date1':
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), 'dd-MMM-yy');
        } else {
          let dateCall = new Date(dateTime);
          let months = [
            'يناير',
            'فبراير',
            'مارس',
            'إبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ];
          let arDate =
            dateCall.getDate() +
            '-' +
            months[dateCall.getMonth()] +
            '-' +
            dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  //---------/\---------SOME SPECIAL FUNCTION'S--------------/\------------
  async ionViewWillEnter() {
    debugger;
    // let options = {
    //   enableHighAccuracy: true,
    //   timeout: 35000
    // };
    // await this.geolocation.getCurrentPosition(options).then((resp) => {
    //   this.Location = true;
    //   return true;
    // }, err => {
    //   this.Location = false;
    //   console.log('Error getting location', err);
    //   return false;
    // });
    this.dateSorting = true;
    this.dateBasedSortingOrder= 'DESC';
    this.statement = false;
    this.address = "";
    this.addressTextArea = "";
    this.getPatientBasicDetails();
    if (this.activeRoute.snapshot.paramMap.get('frmPage') == 'payment') {
      this.prescriptionId = this.activeRoute.snapshot.paramMap.get('prcId');
      this.openOrderDetails(this.prescriptionId, 1);
    } else {
      this.getAdd();
      console.log('test language', this.addCall.selectedLanguage);
      this.advFilter = false;
      this.patientid = localStorage.getItem('patient_id');
      this.filterFromDate = '';
      this.filterToDate = '';
      this.bookingOrderId = '';
      this.paymentGatewayName = '';
      this.tymVal = window.localStorage['PresADD'];
      let CD =new Date().toISOString().split('T')[0] + 'T' + new Date().toTimeString().split(' ')[0];
      console.log('tymVal -> ', this.tymVal, 'CD     -> ', CD);
      this.presentView = 'prescription';
      this.pharmacyStatusId = [];
      switch (localStorage.getItem('NopayGoBack')) {
        case 'newEnter': {
          setTimeout(() => {
            this.showPrescriptionPage();
          }, 1000);
          break;
        }
        case 'BookingConPage': {
          this.openOrderDetails(this.prescriptionId, 1);
          break;
        }
        default: {
          this.showPrescriptionPage();
        }
      }
    }
   this.filterarray = [];
  }

  ionViewWillLeave() {
    this.prescriptionHistory = [];
    this.presentView = 'prescription';
    this.filterarray = [];
  }

  showPrescriptionPage() {
    this.patientid = localStorage.getItem('patient_id');
    this.pageNo = 1;
    this.filterStatus = false;
    this.prescriptionHistory = [];
    this.filterarray = [];
    this.getPrescHis();
    this.preHisFilter();
    this.presentView = 'prescription';
    this.prescription = true;
    this.orderDetails = false;
    this.trackOrders = false;
    this.prescriptionhitory = false;
  }
  showPrescriptionHistoryPage() {
    this.pageNo = 1;
    this.patientid = localStorage.getItem('patient_id');
    this.filterStatus = false;
    this.prescriptionHistory = [];
    this.filterarray = [];
    this.getPresc("");
    this.preHisFilter();
    this.presentView = 'prescriptionhis';
    this.prescriptionhitory = true;
    this.prescription = false;
    this.orderDetails = false;
    this.trackOrders = false;
  }
  backToHome() {
    this.router.navigate(['/tabs/home']);
    this.advFilter = false;
    this.statement = false;
    this.isConfirmed = false

  }

  historyadvfilter: boolean = false;
  openFilter(frm) {
    console.log(frm, '===================');
    console.log('memberDetials', this.memberdetails);

    this.particularPatient = null;
    this.particularmember = null;
    this.srcFromDate = null;
    this.srcToDate = null;
    this.advFilter = true;
    this.historyadvfilter = false;
    if (frm == 2) {
      this.historyadvfilter = true;
    }
  }
  closeFilter2() {
    this.advFilter = false;
  }
  selectBton(index) {
    this.PreHisAdvFilter[index].selected =
      !this.PreHisAdvFilter[index].selected;
    console.log(this.PreHisAdvFilter, '=========');

    if (this.PreHisAdvFilter[index].selected) {
      if (
        this.pharmacyStatusId.indexOf(
          this.PreHisAdvFilter[index].pharmacyStatusId
        ) == -1
      ) {
        this.pharmacyStatusId.push(
          this.PreHisAdvFilter[index].pharmacyStatusId
        );
      }
    } else if (!this.PreHisAdvFilter[index].selected) {
      this.indexFor = this.pharmacyStatusId.indexOf(
        this.PreHisAdvFilter[index].pharmacyStatusId
      );
      this.pharmacyStatusId.splice(this.indexFor, 1);
    }
  }
  searchIt() {
    debugger;
    if (!this.filterFromDate) {
      this.presentToast(this.addCall.title599);
    } else if (!this.filterToDate) {
      this.presentToast(this.addCall.title600);
    } else {
      this.filterStatus = true;
      this.pageNo = 1;
      this.EmtyData = null;
      this.prescriptionHistory = [];
      this.filterarray = [];
      this.getPrescHis();
      this.advFilter = false;
    }
  }
  particularPatient: any;
  listOfstatus() {
    console.log(this.particularPatient);
    this.pharmacyStatusId = this.particularPatient;
  }
  particularmember: any;
  listofmember() {
    console.log(this.particularmember);
    this.patientid = this.particularmember;
  }

  backtoprelistpage: boolean = false;
  openOrderDetails(prescriptionId, frm) {
    console.log(frm, '======');
    this.address = "";
    this.addressTextArea = "";
    this.prescription = false;
    this.prescriptionhitory = false;
    this.backtoprelistpage = false;
    if (frm == 2) {
      this.backtoprelistpage = true;
    }
    this.prescriptionId = prescriptionId;
    this.perticularPharPre();
    this.confirmloc = false;
    this.orderDetails = true;
    this.orderDetails = true;
    this.hideRow = true;
    this.hideRow1 = true;
    this.showRow = false;
    this.advFilter = false;
    this.trackOrders = false;
  }

  backPrescription(type) {
    if (type == 'orderDetails') {
      this.filterFromDate = '';
      this.filterToDate = '';
      this.pharmacyStatusId = '';
      this.getPatientBasicDetails();
      this.getAdd();
      this.showPrescriptionPage();
      this.presentView = 'prescription';
      this.prescription = true;
      this.prescriptionhitory = false;
      this.orderDetails = false;
      this.deleteBox = false;
      this.dltNotify = false;
      this.statement = false;
      this.orderDetails = false;
      this.trackOrders = false;
    } else if (type == 'history') {
      this.getPrescHis();
      this.getAdd();
      this.presentView = 'prescription';
      this.prescription = true;
      this.prescriptionhitory = false;
      this.orderDetails = false;
      this.deleteBox = false;
      this.dltNotify = false;
      this.orderDetails = false;
      this.trackOrders = false;
    }
    this.isConfirmed = false
  }

  openDeleteBox1(index, amount) {
    console.log('LENGTH -> ', this.leng);
    if (this.PerticularPharPre[0].medicineDetails.length > 1) {
      this.selectedIndex = index;
      this.removeamount = amount;
      this.Alertpopup('Do you want to delete this medicine?',102,'classChange');
    } else {
      this.presentToast('You have to place order for minimum 1 item.');
    }
  }

  cancelEvent() {
    this.dltNotify = false;
  }

  okEvent() {
    console.log('LENGTH -> ', this.leng);
    this.deletePescript(this.PerticularPharPre[0].medicineDetails[this.selectedIndex].medicineId);
    this.PerticularPharPre[0].medicineDetails.splice(this.selectedIndex, 1);
    this.PerticularPharPre[0].total_amount -= Number(this.removeamount);
  }

  closeNotify() {
    this.dltNotify = false;
  }

  toChange() {
    this.presentView = 'maptab';
    this.prescription = false;
    this.orderDetails = false;
    this.trackOrders = false;
    this.prescriptionhitory = false;
    setTimeout(() => {
      this.loadmap();
    }, 1000);
  }

  backToBooking(val) {
    debugger;
    this.presentView = 'orderDetails';
    this.prescription = false;
    this.orderDetails = true;
    this.trackOrders = false;
    this.prescriptionhitory = false;
    console.log(val);
    if (val == 2) {
      this.addressTextArea = this.address;
    } else {
      let message = ``;
      this.Alertpopup2(message, 4);
    }
  }

  toSave() {
    this.hideRow = true;
    this.hideRow1 = true;
    this.showRow = false;
  }

  paymentid: any;


  checkboxClick(e) {
    console.log("event click", e.target.checked)
    if (e.target.checked == true) {
      this.statement = true;
    }
    else {
      this.statement = false;
    }
  }

  async goToPayment() {
    console.log("statement", this.statement);
    if (this.statement == true) {
      console.log("confirmation", this.confirmloc);
      if (this.confirmloc == true) {
        this.confirmloc = false;
        if (this.paidAmount != 0) {
          let name;
          if (this.activeRoute.snapshot.paramMap.get('frmPage') == 'payment') {
            name = this.memberdetails[0].membername;
          } else {
            name = this.prescriptionHistory[0].patient_name;
          }
          console.log(name, this.paidAmount);
          await this.presentModal1(name,this.memberdetails[0].email,this.memberdetails[0].phoneNo,this.paidAmount);
        }
      } else {
        let message = ``;
        this.Alertpopup2(message, 4);
      }
    }
    else {
      this.statement = false;
    }
  }

  async patientPharmacyConfirmOrder(res: any) {
    const loader = await this.loadingController.create({
      message: 'Processing Your Payment Status',
    });
    await loader.present();
    let getDate = new Date();
    let addressData = (this.addressTextArea == '' || this.addressTextArea == undefined ||  this.addressTextArea == null)
        ? this.address : this.addressTextArea;
    let crnDate =  getDate.getFullYear() +  '-' + ('0' + (getDate.getMonth() + 1)).slice(-2) + '-' + ('0' + getDate.getDate()).slice(-2);
    let requestdata = JSON.stringify({
      prescriptionId: this.preIdConf,
      orderId: this.orderId,
      deliveryAddress: addressData,
      paidAmount: this.paidAmount,
      paymentStatus: 1,
      confirmDateTime: crnDate + ' ' + new Date().toTimeString().split(' ')[0], //"2021-08-09 16:45:30",
      latitude: this.latitude,
      longitude: this.longitude,
      paymentid: this.paymentid,
      referenceid: this.referenceid,
      bookingOrderId: this.bookingOrderId,
      paymentGateway: this.paymentGatewayName,
    });
    this.services
      .postRequest('patientPharmacyConfirmOrder', requestdata)
      .subscribe(async (response) => {
        console.log(response);
        await loader.dismiss();
        if (response.status == 1) {
          setTimeout(() => {
            this.loadingController.dismiss();
          }, 500);
          if (localStorage.getItem('cardType') == 'Knet') {
            this.showKnetPaymentDetals(res, this.addCall.title620);
          } else if (localStorage.getItem('cardType') == 'MasterCard') {
            this.router.navigate(['/payment', { paymentstatus: 1 }]);
          }
        } else {
          setTimeout(() => {
            this.loadingController.dismiss();
          }, 500);
        }
      });
  }

  cancelOrder() {
    let message = ``;
    this.Alertpopup2(message, 44);
  }

  parientname: any;
  trackOrder(docName, orderNum, dateTime, patientname) {
    this.docName = docName;
    this.orderNum = orderNum;
    this.dateTime = dateTime;
    this.parientname = patientname;
    this.pharmacyOrderTracking(this.orderId);
    this.presentView = 'trackOrders';
    this.trackOrders = true;
    this.orderDetails = false;
    this.prescription = false;
    this.prescriptionhitory = false;
  }

  backToBookAndDelivery() {
    this.perticularPharPre();
    this.presentView = 'orderDetails';
    this.orderDetails = true;
    this.prescription = false;
    this.trackOrders = false;
    this.prescriptionhitory = false;
  }

  gatewayFunction(res: any, paymentGateway: any) {
    if (res.status == '1') {
      this.paymentid = res.resultid;
      this.referenceid = res.sessionid;
      this.bookingOrderId = res.orderId;
      this.paymentGatewayName = res.paymentGatewayName;
      this.patientPharmacyConfirmOrder(res);
    } else if (res.status == '2') {
      this.Alertpopup(this.addCall.title144, 0);
    } else {
      console.log('payment faild');
      if(paymentGateway=="KNET"){
        this.showKnetPaymentDetals(res, 'Payment Failure Details');
      } else {
        this.Alertpopup(this.addCall.title144, 0);
      }
    }
  }

  getPrescHis() {
    try {
      this.nextCount = 0;
      if (this.pageNo == 1) {
        this.EmtyData = null;
      }
      let requestdata = JSON.stringify({
        patientId: localStorage.getItem('patient_id'),
        filter: this.filterStatus,
        statusIdList: this.pharmacyStatusId.toString(),
        filterFromDate: this.filterFromDate,
        filterToDate: this.filterToDate,
        dateBasedSorting: this.dateSorting,
        dateBasedSortingOrder: this.dateBasedSortingOrder,
        limit: 15,
        pageno: this.pageNo,
        status: 1,
      });
      this.services
        .postRequest('patientPrescriptionHistoryDetails', requestdata)
        .subscribe(
          (response) => {
            debugger;
            this.currentDate = new Date();
            this.currentDate.setDate(new Date().getDate() -3);
            this.currentDate = new Date(this.currentDate).toISOString().split('T')[0];
            console.log(response);
            if (this.pageNo != 1 && response.data.length != 0) {
              response.data[0].details.forEach(async (item)=>{
                const  formatedDate = new Date(item.orderStatusDate).toISOString().split('T')[0];
               if(item.orderStatusId != 4 &&(item.orderStatusId ==8 ? this.currentDate <= formatedDate : item.orderStatusId !==8)){
                this.filterarray.push(item);}
              });
              this.nextCount = response.data[0].nextCount;
              this.prescriptionHistory = this.filterarray;
            } else if (this.pageNo == 1 && response.data.length != 0) {
              response.data[0].details.forEach(async (item)=>{
              const  formatedDate = new Date(item.orderStatusDate).toISOString().split('T')[0];
             if(item.orderStatusId != 4 &&(item.orderStatusId ==8 ? this.currentDate <= formatedDate : item.orderStatusId !==8)){
              this.filterarray.push(item);}
              });
              this.EmtyData = response.status;
              this.nextCount = response.data[0].nextCount;
              this.prescriptionHistory = this.filterarray;
            } else {
              this.EmtyData = response.status;
              this.prescriptionHistory = [];
              this.filterarray = [];
              this.nextCount = 0;
            }
            this.refFunc();
            this.infyFunc();
          },
          (err) => {
            console.log(err);
            this.refFunc();
            this.infyFunc();
          }
        );
    } catch (err) {
      console.log(err);
      this.refFunc();
      this.infyFunc();
    }
  }

  getPresc(frompage) {
    this.presentView = 'orderDetails';
    if (this.orderDetails == false) {
      this.presentView = 'prescriptionhis';
    }
    if(frompage !='History'){
    this.prescriptionHistory = [];
    this.filterarray = [];
    this.pageNo = 1;
    }
    debugger;
    try {
      this.nextCount = 0;
      if (this.pageNo == 1) {
        this.EmtyData = null;
      }
      let requestdata = JSON.stringify({
        patientId: localStorage.getItem('patient_id'),
        filter: this.filterStatus,
        statusIdList: this.pharmacyStatusId.toString(),
        filterFromDate: this.filterFromDate,
        filterToDate: this.filterToDate,
        limit: 15,
        pageno: this.pageNo,
      });
      this.services
        .postRequest('patientPrescriptionhispageDetails', requestdata)
        .subscribe(
          (response) => {
            debugger;
            this.currentDate = new Date();
            this.currentDate.setDate(new Date().getDate() -3);
            this.currentDate = new Date(this.currentDate).toISOString().split('T')[0];
            console.log(response);
            if (this.pageNo != 1 && response.data.length != 0) {
              response.data[0].details.forEach(async (item)=>{
                const  formatedDate = new Date(item.orderStatusDate).toISOString().split('T')[0];
               if(item.orderStatusId ==8 ? formatedDate <= this.currentDate : item.orderStatusId ==4){
                this.filterarray.push(item);}
              });
              this.nextCount = response.data[0].nextCount;
              this.prescriptionHistory = this.filterarray;
            } else if (this.pageNo == 1 && response.data.length != 0) {
              response.data[0].details.forEach(async (item)=>{
                const  formatedDate = new Date(item.orderStatusDate).toISOString().split('T')[0];
               if(item.orderStatusId ==8 ? formatedDate <= this.currentDate : item.orderStatusId ==4){
                this.filterarray.push(item);}
              });
              this.EmtyData = response.status;
              this.nextCount = response.data[0].nextCount;
              this.prescriptionHistory = this.filterarray;
            } else {
              this.EmtyData = response.status;
              this.prescriptionHistory = [];
              this.nextCount = 0;
            }
            this.refFunc();
            this.infyFunc();
          },
          (err) => {
            console.log(err);
            this.refFunc();
            this.infyFunc();
          }
        );
    } catch (err) {
      console.log(err);
      this.refFunc();
      this.infyFunc();
    }
  }

  historyprepage: any = [];

  preHisFilter() {
    this.services.getRequest('statusListForFilter').subscribe((response) => {
      console.log(response);
      this.historyprepage = [];
      this.PreHisAdvFilter = [];
      for (let item of response.data) {
        if (item.pharmacyStatusId != 4 && item.pharmacyStatusId != 8) {
          this.PreHisAdvFilter.push({
            pharmacyStatusId: item.pharmacyStatusId,
            status: item.status,
            selected: false,
          });
        }
      }
      let filterarray = [];
      filterarray = response.data;

      filterarray.forEach((data) => {
        if (data.pharmacyStatusId == 4 || data.pharmacyStatusId == 8) {
          this.historyprepage.push(data);
        }
      });
      console.log(this.historyprepage);
    });
  }
  goBack() {
    debugger;
    switch ('gobackhis') {
      case 'gobackhis':
        this.ChangeEventPharma.emit('isTrainerBackBooking');
        this.isShowHeaderValue = false;
        this.orderDetails = false;
        this.presentView = 'prescriptionhis';
        this.getPresc("");
        break;

      default:
        break;
    }
  }
  perticularPharPre() {
    debugger;
    this.ChangeEventPharma.emit('profile');
    this.isShowHeaderValue = false;
    this.backValue = 'gobackhis';
    if (this.appoinbackhead == false) {
      this.isShowHeaderValue = true;
    }
    let requestdata = JSON.stringify({
      prescriptionId: this.prescriptionId,
    });
    this.services
      .postRequest('particularPharmacyPrescriptionDetails', requestdata)
      .subscribe((response) => {
        console.log(response);
        this.presentView = 'orderDetails';
        if (response.data.length > 0) {
          this.PerticularPharPre = response.data;
          this.addressTextArea = response.data[0].deliveryAddress;
          this.leng = this.PerticularPharPre[0].medicineDetails.length;
          this.preIdConf = response.data[0].prescriptionId;
          this.orderId = response.data[0].orderId;
          this.deliveryAddress = response.data[0].deliveryAddress;
          this.paidAmount = response.data[0].total_amount;
          this.paymentStatus = response.data[0].payment_status;
        } else {
          this.PerticularPharPre = [];
          this.addressTextArea = [];
        }
      });
  }

  deletePescript(medicineId) {
    let requestdata = JSON.stringify({
      medicineId: medicineId,
    });
    this.services
      .postRequest('deletePresctiptMedicine', requestdata)
      .subscribe((response) => {
        console.log(response);
        this.DeletePescript = response.msg;
        this.perticularPharPre();
        if (response.status == 1) {
          this.AlertpopupPrc('Deleted Successfully!', response.status);
        } else {
          this.AlertpopupPrc(response.msg, response.status);
        }
      });
  }

  async cancelPharPresOrder() {
    let getDate = new Date();
    let crnDate = getDate.getFullYear() + '-' + ('0' + (getDate.getMonth() + 1)).slice(-2) + '-' + ('0' + getDate.getDate()).slice(-2);
    const loader = await this.loadingController.create({
      message: 'Loading......please Wait',
    });
    await loader.present();
    let requestdata = JSON.stringify({
      orderId: this.orderId,
      canceledDateTime: crnDate + ' ' + new Date().toTimeString().split(' ')[0],
    });
    this.services
      .postRequest('cancelPharmacyPresctiptionOrder', requestdata)
      .subscribe(async (res) => {
        console.log(res);
        await loader.dismiss();
        if (res.status == 1) {
          this.Alertpopup2(this.addCall.title586, res.status);
          this.backPrescription('orderDetails');
        } else {
          this.Alertpopup2(res.msg, res.status);
        }
      });
  }

  pharmacyOrderTracking(orderId) {
    this.orderTracking = [];
    let requestdata = JSON.stringify({
      order_id: this.orderId,
    });
    this.services
      .pharmacyRequest('viewOrderStatus', requestdata)
      .subscribe((response) => {
        console.log(response);
        if (response.data.length > 0) {
          const seen = new Set();
          const filteredArr = response.data.filter((el) => {
            const duplicate = seen.has(el.status_id);
            seen.add(el.status_id);
            return !duplicate;
          });
          console.log(filteredArr, 'unique order');

          for (let item of filteredArr) {
            if (
              item.status_id >= 3 &&
              item.status_id != 4 &&
              item.status_id != 7
            ) {
              this.orderTracking.push({
                ph_date: item.ph_date,
                ph_time: item.ph_time,
                ph_order_id: item.ph_order_id,
                status: item.status,
                status_id: item.status_id,
              });
            }
          }
        } else {
          this.orderTracking = [];
        }
        if (this.orderTracking.length < 4) {
          for (let i = this.orderTracking.length; i <= 4; i++) {
            this.orderTracking.push({
              ph_date: null,
              ph_time: null,
              ph_order_id: null,
              status: null,
              status_id: null,
            });
          }
        }
      });
  }


   loadmap() {
    // Request needed libraries.
    debugger;
    let latLng = new google.maps.LatLng(this.latitude, this.longitude);
    let mapOptions = {
          center: latLng,
          zoom: 15,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          map: this.map,
        };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);

    // Create a marker and set its position.
    let marker = new google.maps.Marker({
      position: latLng,
      map: this.map,
      title: "Current Location",
      animation: google.maps.Animation.DROP
    });

    // Configure the click listener.
    this.map.addListener("click", (mapsMouseEvent) => {
      debugger;
      let map_position = JSON.stringify(mapsMouseEvent.latLng.toJSON());
      let map_current_Lat_Long = JSON.parse(map_position);
      this.latitude = map_current_Lat_Long.lat;
      this.longitude = map_current_Lat_Long.lng;

      // Update marker position.
      marker.setPosition(mapsMouseEvent.latLng);

      let url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${this.latitude}&lon=${this.longitude}&zoom=18&addressdetails=1`;
      this.http.get(url).subscribe((res: any) => {
          let address_form = res.display_name;
          this.address = address_form;
          console.log(this.address, "address");
          this.cdr.detectChanges();
        },
        (error) => {
          console.log(error,"map_error");
        }
      );
    });
  }


  memberdetails: any;

  getPatientBasicDetails() {
    this.appoinbackhead = true;
    this.memberdetails = [];
    let apiData = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
      currentDate: new Date().toISOString().split('T')[0],
      currentTime: new Date().toTimeString().split(' ')[0],
    });
    console.log('send patient Basic Details Reqst=>', JSON.parse(apiData));
    this.services.postRequest('getPatientProfile', apiData).subscribe((res) => {
      let date = res.data[0];
      console.log(date);

      this.memberdetails.push({
        membername: date.name,
        memberid: date.patientId,
        email: date.email,
        phoneNo: date.phone_no,
      });

      for (let item of date.patientmemberDetails) {
        this.memberdetails.push({
          membername: item.name,
          memberid: item.PatientMemberId,
        });
      }
      console.log(this.memberdetails, '===================');
    });
  }

  prescriptionlist(ope, amount, index) {
    console.log('check prescripation', ope);
    console.log(this.PerticularPharPre);
    if (ope == 'sub') {
      if (this.PerticularPharPre[0].medicineDetails[index].quantity != 1) {
        console.log(this.PerticularPharPre[0].medicineDetails[index]);
        this.PerticularPharPre[0].medicineDetails[index].amount = Number(
          this.PerticularPharPre[0].medicineDetails[index].amount -
          this.PerticularPharPre[0].medicineDetails[index].unit_rate
        );
        this.PerticularPharPre[0].medicineDetails[index].quantity =
          Number(this.PerticularPharPre[0].medicineDetails[index].quantity) - 1;
        this.PerticularPharPre[0].total_amount =
          Number(this.PerticularPharPre[0].total_amount) -
          this.PerticularPharPre[0].medicineDetails[index].unit_rate;
        this.paidAmount = this.PerticularPharPre[0].total_amount;
      }
    } else if (ope == 'add') {
      console.log(this.PerticularPharPre[0].medicineDetails[index]);
      this.PerticularPharPre[0].medicineDetails[index].amount = Number(
        this.PerticularPharPre[0].medicineDetails[index].amount +
        this.PerticularPharPre[0].medicineDetails[index].unit_rate
      );
      this.PerticularPharPre[0].medicineDetails[index].quantity =
        Number(this.PerticularPharPre[0].medicineDetails[index].quantity) + 1;
      this.PerticularPharPre[0].total_amount =
        Number(this.PerticularPharPre[0].total_amount) +
        this.PerticularPharPre[0].medicineDetails[index].unit_rate;
      this.paidAmount = this.PerticularPharPre[0].total_amount;
    }
  }

  ngOnChanges() {
    if (this.showTypeofBooking == 'booking hitory') {
      this.pharmacyStatusId = [];
      this.showPrescriptionHistoryPage();
    }
  }
  // =============================Advertismenet======================
  getAdd() {
    try {
      let min = new Date(new Date().setTime(new Date().getTime() + 3600000));
      let CT = min.toISOString().split('T')[0] + 'T' +  min.toTimeString().split(' ')[0];
      this.tymVal = CT;
      window.localStorage['DocADD'] = CT;

      let today = new Date().toISOString().split('T')[0];
      let data = JSON.stringify({
        vendor_type_id: 9,
        current_date: today
      });
      this.services
        .postRequestGndrl('admin/get_current_advertisement', data)
        .subscribe(
          (res) => {
            if (res.data.length > 0) {
              this.addImg = res.data[0].ad_path_name;
              if (res.data[0].ad_size == '2') {
                this.dynClass = 'advertisement1';
              } else if (res.data[0].ad_size == '1') {
                this.dynClass = 'advertisement2';
              }
              this.openAdvr();
            }
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }

  async openAdvr() {
    window.localStorage['addType'] = 2;
    let popover = await this.modalCtrl.create({
      component: AdvertisementPage,
      componentProps: {
        addImg: this.addImg,
      },
      cssClass: this.dynClass,
    });
    return await popover.present();
  }

  async presentModal1(name, email, phoneNo, paidAmount) {
    this.statement = true
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: 'SUCCESS!',
        messageContent: 'pay',
      },
    });
    modal.onDidDismiss().then(async (data) => {
      console.log('data', data);
      this.gopayment = true;
      this.payType = data.data;
      const loader = await this.loadingController.create({
        message: 'Please wait we are redirecting you to the payment gateway',
      });
      if (data.data == '1') {
        await loader.present();
        this.payment
          .getsessionid(name, email, phoneNo, paidAmount)
          .then(async (res: any) => {
            await loader.dismiss();
            console.log(res, 'response');
            this.gatewayFunction(res, "MASTER");
          });
      } else if (data.data == '2') {
        await loader.present();
        this.payment
          .getKnetsessionid('', email, phoneNo, paidAmount)
          .then(async (res: any) => {
            await loader.dismiss();
            console.log(res, 'response');
            this.gatewayFunction(res, "KNET");
          });
      }
      // else if (data.data == '3') {
      //   await loader.present();
      //   this.payment
      //     .getApplesessionid(name, email, phoneNo, paidAmount)
      //     .then(async (res: any) => {
      //       await loader.dismiss();
      //       console.log(res, 'response');
      //       this.gatewayFunction(res, "APPLE PAY");
      //     });
      // }

      this.payType = '';
      this.gopayment = false;
    });
    return await modal.present();
  }

  async showKnetPaymentDetals(data: any, msg: string) {
    const modal = await this.modalCtrl.create({
      component: knetPaymentDetailsPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: msg,
        messageContent: data,
      },
    });

    modal.onDidDismiss().then(async (data) => {
      if (msg === 'Payment Success Details') {
        this.router.navigate(['/payment', { paymentstatus: 1 }]);
      }
    });
    return await modal.present();
  }

  async OpenMapMethod(clinicname: any, clinic_address: any, clinic_lat_long: any) {
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      cssClass: 'mapmodel',
      componentProps: {
        typeValue: 33,
        clinicname: clinicname,
        clinic_address: clinic_address,
        clinic_lat_long: clinic_lat_long,
      }
    });
    // modal.onDidDismiss()
    // .then((data) => {
    //   if (data.data == "Map_Not_Show") {
    //      this.ionViewWillEnter();
    //   }
    // });
    return await modal.present();
  }


  decryptContent(encryptedContent: string): string {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, this.fkey, {
        iv: this.fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return error.message;
    }
  }
  formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  }

  openTerms() {
    const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
    const params = new HttpParams().set('vendorcategory', 'Pharmacy');

    this.http.get<DecryptedMemberContentResponse>(url, { params })
      .subscribe(
        response => {
          if (response && response.data && response.data.length > 0) {
            const lastIndex = response.data.length - 1;
            this.terms_and_condition_file = response.data[lastIndex].Terms_and_conditions;
            const decryptedData = this.decryptContent(this.terms_and_condition_file);
            console.log("Decrypted data:", decryptedData);
            if (!decryptedData) {
              throw new Error('Decryption failed');
            }

            const content = htmlToPdfmake(decryptedData);
            console.log("PDF content:", content);

            if (!content || !Array.isArray(content)) {
              throw new Error('Invalid content structure');
            }

            const documentDefinition = {
              content: content,
              styles: {
                header: {
                  fontSize: 12,
                  bold: true,
                  margin: [40, 10, 40, 10],
                },
                footer: {
                  fontSize: 10,
                  margin: [40, 0, 40, 0],
                },
                footerText: {
                  fontSize: 10,
                },
              },
              header: (currentPage, pageCount, pageSize) => {
                const modified_on =  new Date();
                return {
                  text: ``,
                  alignment: 'left',
                  style: 'header',
                  color: '#510F30',
                  margin: [30, 40, 0, 0],
                };
              },
              footer: (currentPage, pageCount, pageSize) => {

                const modified_on =  new Date();

                return {
                  margin: [40, 40, 40, 40],
                  columns: [
                    {
                      stack: [
                        {
                          text: `Page ${currentPage}/${pageCount}`,
                          alignment: "right",
                          color: "#510F30",
                          style: "footerText",
                        },
                      ],
                    },
                  ],
                };
              },
              pageMargins: [40, 70, 40, 180],
            };
            pdfMake.createPdf(documentDefinition).getBlob(async (blob: Blob) => {
              console.log("PDF Blob:", blob);
              try {
                const localBlob = new Blob([blob], { type: 'application/pdf' });
                const fileName = `report_${new Date().getTime()}.pdf`;
                await this.file.writeFile(this.file.dataDirectory, fileName, localBlob, { replace: true })
                  .then((fileEntry) => {
                    console.log("File entry:", fileEntry);
                    this.fileOpener.open(fileEntry.nativeURL, 'application/pdf')
                      .then(() => console.log('File is opened'))
                      .catch(e => console.log('Error opening file', e));
                  })
                  .catch(e => console.log('Error writing file', e));
              } catch (error) {
                console.error('Error uploading file', error);
              }
            });

          } else {
            console.error('Unexpected response format:', response);
          }
        },
        error => {
          console.error('Error:', error);
        }
      );
  }

}
